import { Action, createReducer, on } from '@ngrx/store';
import { ComplianceRequirementDescriptionsState } from '../state/compliance-requirement-descriptions.state';
import {
    getAcceptanceRuleLookupsFailure,
    getAcceptanceRuleLookupsSuccess,
    setAcceptanceRuleLookupsIsLoadingFlag
} from '../actions/compliance-requirement-descriptions.actions';

const initialState = {
    acceptanceRuleLookups: undefined,
    acceptanceRuleLookupsIsLoading: false,
    error: undefined
} as ComplianceRequirementDescriptionsState;

const reducer = createReducer(
    initialState,
    on(getAcceptanceRuleLookupsSuccess, (state, action) => ({
        ...state,
        acceptanceRuleLookups: action.acceptanceRuleLookups,
        error: undefined
    })),
    on(getAcceptanceRuleLookupsFailure, (state, action) => ({
        ...state,
        acceptanceRuleLookups: undefined,
        error: action.error
    })),
    on(setAcceptanceRuleLookupsIsLoadingFlag, (state, action) => ({
        ...state,
        acceptanceRuleLookupsIsLoading: action.isLoading
    }))
);

export function complianceRequirementDescriptionsReducer(
    state: ComplianceRequirementDescriptionsState | undefined,
    action: Action
) {
    return reducer(state, action);
}
